/* eslint-disable prettier/prettier */
import vant from "./vant";
const Plugins = {
  install: function (Vue) {
    Vue.use(vant);
  },
};
export default Plugins;
